export const i18nConfig = {
  defaultLocale: 'en-us',
  locales: ['en-us', 'fr', 'es', 'it', 'ar', 'de', 'nl'],
};
